import store from "redux/store";
import CustomRoutes, { mainRoutes } from "routes";
import { ThemeProvider } from "./AppContext";
import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import { Provider } from "react-redux";
import { SelectedQuoteProvider } from "contexts/selected-quote-context";

function App() {
  return (
    <BrowserRouter>
      <Provider store={store} >
        <SelectedQuoteProvider>
          <ThemeProvider>
            <Suspense>
              <CustomRoutes routes={mainRoutes} />
            </Suspense>
          </ThemeProvider>
        </SelectedQuoteProvider>
      </Provider >
    </BrowserRouter>
  );
}

export default App;
